import Vue from 'vue'

let path = require('path')

const files = require.context('./modules', true, /\.js$/)
files.keys().forEach(filePath => {
  let directiveName = path.dirname(filePath).split('/')[1]
  const directiveFunc = files(filePath).default
  Vue.directive(directiveName, directiveFunc)
})
